"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumericDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var isNumericDependencies = exports.isNumericDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createIsNumeric: _factoriesAny.createIsNumeric
};